<template>
    <form>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
            <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="goBack">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
        </p>
        <p class="d-inline-flex">
            <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="!isNew()" @click.prevent="handleDelete('delete')" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.delete')}}
            </a>
            <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="isNew()" @click.prevent="handleDelete('cancel')" style="padding: 7px 10px; margin-right: 20px;margin-bottom: 0;">
              <img src="/static/img/icons/icon-close.png">
              {{$t('general.cancel')}}
            </a>
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;"  @click.prevent="validate" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
          </p>
        </div>
      </div>
      <div class="card mar-to-15">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
        <div class="card-content">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>{{$t('menuLink.title')}}</label>
                <input type="text"  class="form-control"
                  name="name"
                  :placeholder="$t('menuLink.title')"
                  v-model="model.title"
                  v-validate="modelValidations.title"
                  />
              </div>
              <small class="text-danger" v-if="errors.has('title')">
                {{ getError('title') }}
              </small>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                  <div>
                    <label class="pad-to-10">{{$t('menuLink.alias')}}</label>
                    <select class="form-control"
                            v-model="model.alias"
                            v-validate="modelValidations.alias"
                            name="alias">
                      <template v-for="(alias, index) in aliases">
                        <option
                          :value="alias"
                          :key="index"
                          :selected="index === model.alias && !isNew()"
                          >{{$t('menuLink.' + alias)}}
                        </option>
                      </template>
                    </select>
                    <small class="text-danger" v-if="errors.has('alias')">
                      {{ getError('alias') }}
                    </small>
                  </div>
              </div>
              <template v-if="model.alias =='custom'">
                <label class="pad-to-10">{{$t('menuLink.externUrl')}}</label>
                <div class="form-group">
                  <input type="text" v-model="model.external_url" :placeholder="$t('menuLink.externUrl')" class="form-control">
                </div>
              </template>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('catalogProd.image') }}</label>
                <el-upload
                  action=""
                  ref="upload"
                  :limit="1"
                  :file-list="model.image"
                  list-type="picture-card"
                  accept=" .jpg, .jpeg, .png"
                  :on-change="handleImgChnage"
                  :on-exceed="handleExceed"
                  :on-remove="handleRemove"
                  :auto-upload="false">
                  <img src="/static/img/icons/icon-plus-primary.png">
                  <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
</template>
<script>
  import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import {Input, Button, Select} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-wysiwyg/dist/vueWysiwyg.css'
  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select
    },
    computed: {
      ...mapFields(['title', 'alias', 'sort_order', 'image'])
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        model: {},
        modelValidations: {
          title: {
            required: true,
            min: 5
          },
          alias: {
            required: true
          }
        },
        loading: true,
        aliases: null,
        imagelist: []
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      this.aliases = this.$session.get('defaultData')['menu_link_aliases']
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      if (this.route.params.id) {
        var id = this.route.params.id
        this.apiRequest('/menulink/' + id, 'GET', data, (response) => {
          if (response.status === true) {
            this.model = response.data
            if (response.data.image) {
              response.data.image = [{url: response.data.image}]
            } else {
              response.data.image = []
            }
            this.$nextTick(() => { this.loading = false })
          } else {
            this.$nextTick(() => { this.loading = false })
          }
        })
      }
      this.$nextTick(() => { this.loading = false })
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.errors.clear()
            this.savePage()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop])
          }
        }
      },
      isNew () {
        if (this.route.params.id) {
          return false
        } else {
          return true
        }
      },
      handleDelete (label) {
        swal({
          text: this.$t('menuLink.areYouSure', {label: this.$t('menuLink.' + label)}),
          type: 'question',
          showCancelButton: true,
          cancelButtonText: this.$t('general.cancel'),
          confirmButtonText: this.$t('general.yes')
        })
        .then((result) => {
          if (result) {
            if (this.isNew()) {
              // this.router.push('/menu-links')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              var id = this.route.params.id
              var data = {
                id: id,
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany')
              }
              this.apiRequest('/menulink/' + id, 'DELETE', data, (response) => {
                if (response.status === true) {
                  swal({
                    text: this.$t('menuLink.deleted'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  })
                  // this.router.push('/menu-links')
                  this.$bus.$emit('refresh')
                  this.$bus.$emit('close-modal')
                } else {
                  swal(
                    '',
                    response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                    'error'
                  )
                }
              })
            }
          }
        })
      },
      handleImgChnage (file, fileList) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: 'Please remove the current file in order to be able to add a new one',
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          }).then(() => {})
          .catch(() => {})
        }
        return isOkSize
      },
      savePage () {
        this.loading = true
        var data = this.model
        delete data.image
        var self = this
        data.token = this.$session.get('token')
        data.company_id = this.$session.get('selectedCompany')
        if (this.isNew()) {
          this.apiRequest('/menulink', 'POST', data, (response) => {
            if (response.status === true) {
              var id = response.data.id
              var data2 = {
                token: this.$session.get('token'),
                company_id: this.$session.get('selectedCompany'),
                sort_order: id
              }
              if (self.model.imagelist && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data3 = {}
                    data3.id = response.data.id
                    data3.token = data2.token
                    data3.company_id = data2.company_id
                    data3.image = base64enc
                    data3.sort_order = data2.sort_order

                    this.apiRequest('/menulink/' + id, 'PUT', data3, (response2) => {
                      if (response2.status === true) {
                        this.$nextTick(() => { this.loading = false })
                        swal(
                          {
                            title: '',
                            text: this.$t('menuLink.added'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {})
                        // this.router.push('/menu-links')
                        this.$bus.$emit('refresh')
                        this.$bus.$emit('close-modal')
                      } else {
                        this.$nextTick(() => { this.loading = false })
                        swal(
                          {
                            title: '',
                            text: this.$t('menuLink.couldNotSave'),
                            type: 'error',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        ).catch(() => {})
                        this.$nextTick(() => { this.loading = false })
                      }
                    })
                  }
                )
              } else {
                this.$nextTick(() => { this.loading = false })
                swal(
                  {
                    title: '',
                    text: this.$t('menuLink.added'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                ).catch(() => {})
                // this.router.push('/menu-links')
                this.$bus.$emit('refresh')
                this.$bus.$emit('close-modal')
              }
            } else {
              this.$nextTick(() => { this.loading = false })
              this.handleErrors(response.errors)
            }
          })
        } else {
          var id = this.route.params.id
          this.apiRequest('/menulink/' + id, 'PUT', data, (response) => {
            if (response.status === true) {
              if (self.model.imagelist && self.model.imagelist[0].status && self.model.imagelist[0].status === 'ready') {
                self.getBase64(self.model.imagelist[0].raw).then(
                  (base64enc) => {
                    var data2 = {}
                    data2.id = id
                    data2.token = data.token
                    data2.company_id = data.company_id
                    data2.image = base64enc

                    self.apiRequest('/menulink/' + id, 'PUT', data2, function (response2) {
                      if (response2.status === true) {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('menuLink.updated'),
                            type: 'success',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                        if (typeof self.callback === 'function') {
                          self.callback()
                        }
                      } else {
                        self.$nextTick(function () { self.loading = false })
                        swal(
                          {
                            title: '',
                            text: self.$t('menuLink.couldNotUpdate'),
                            type: 'danger',
                            showConfirmButton: false,
                            timer: 1500
                          }
                        )
                        .then(() => {})
                        .catch(() => {}) // end swal
                      }
                    }) // end api response2
                  }
                ) // end getBase64.then
              } else {
                self.$nextTick(function () { self.loading = false })
                swal(
                  {
                    title: '',
                    text: self.$t('menuLink.updated'),
                    type: 'success',
                    showConfirmButton: false,
                    timer: 1500
                  }
                )
                .then(() => {})
                .catch(() => {})
                if (typeof self.callback === 'function') {
                  self.callback()
                }
              }
              this.$nextTick(() => { this.loading = false })
              swal(
                {
                  title: '',
                  text: this.$t('menuLink.updated'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {})
              this.$nextTick(() => { this.loading = false })
              // this.router.push('/menu-links')
              this.$bus.$emit('refresh')
              this.$bus.$emit('close-modal')
            } else {
              this.$nextTick(() => { this.loading = false })
              this.handleErrors(response.errors)
              swal(
                {
                  title: '',
                  text: this.$t('menuLink.couldNotUpdate'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {})
            }
          })
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/MenuLinks/MenuLinkForm.vue